import opcodes from "../sx/src/lib/opcodes";
import { projectFunctions } from "../contexts/IDEContext.js";

const createHoverMessages = () => {
  const projectFnMsgs = (projectFunctions || [])
    .filter(f => f && f.description && f.name)
    .map(f => ({
      value: f.name,
      description: f.description
    }));

  return [...opcodes, ...projectFnMsgs];
};
 
 export const hoverMessages = createHoverMessages();